import * as React from "react";
import styles from './Examinator.css';
import { v4 } from "uuid";

import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Badge from '@material-ui/core/Badge';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';

import "./../../resources/forest.jpg";

import { ThemeProvider } from '@material-ui/core/styles';

import { createMuiTheme } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';

import CircularProgress from '@material-ui/core/CircularProgress';

import Login from "./Login";
import Exam from "./Exam";
import FinishExam from "./FinishExam";
import LegalNotice from "./LegalNotice";
import PrivacyPolicy from "./PrivacyPolicy";
import ResponsivePaper from "./ResponsivePaper";

import ExamServer from '../server/ExamServer'
import ExamExercise from "./ExamExercise";
import Administration from "./Administration";
import { Hidden } from "@material-ui/core";



// import ResultItem, { EPSRequestState } from "./ResultItem";
// import ResultList from "./ResultList";



const theme = createMuiTheme({
    palette: {
        // primary: {
        //     main: '#44423e'
        // },
        // secondary: {
        //     main: '#FDC400',
        //     contrastText: '#fff'
        // }
    }

});

export interface ExaminatorProps {

}

export interface ExaminatorState {
    //activationCode: boolean
    roomEntered: boolean
    started: boolean
    timeExceeded: boolean
    finished: boolean
    administration: boolean
    loading: boolean
    legalNotice: boolean
    privacyPolicy: boolean
}

// export const Hello = (props: HelloProps) => <h1 className={styles.bg}>Hello from {props.compiler} and {props.framework}!</h1>;

class Examinator extends React.Component<ExaminatorProps, ExaminatorState> {

    server: ExamServer;

    constructor(props: ExaminatorProps) {
        super(props);
        this.state = {
            roomEntered: false,
            started: false,
            timeExceeded: false,
            finished: false,
            administration: false,
            loading: true,
            legalNotice: false,
            privacyPolicy: false
        }

        this.server = new ExamServer()
        this.server.getSession().then(session => {

            this.setState({
                roomEntered: session.roomId !== undefined,
                started: session.executionStarted !== undefined && session.executionStarted,
                finished: session.executionFinished !== undefined && session.executionFinished,
                loading: false
            })
        })
    }

    enterRoom = () => {
        this.setState({
            roomEntered: true
        })
    }

    examStarted = () => {
        this.setState({
            started: true
        })
    }

    // handleCancel = () => {
    //     this.setState({
    //         openConfigurator:false
    //     })
    // }

    handleTimeExceeded = () => {


        this.setState({
            timeExceeded: true
        })

        this.server.finishExam()
    }

    handleFinished = () => {
        this.setState({
            finished: true
        })
        this.server.finishExam()
    }




    render() {
        return (
            <React.Fragment>
                <CssBaseline />
                <ThemeProvider theme={theme}>

                    {this.state.loading ? (
                        <div className={styles.bg}>
                             <Grid container
                                justify="center"
                                alignItems="center"
                                style={{
                                    height: "calc(100vh - 300px)"
                                }}
                            >
                                <Grid item md={8} lg={6} xl={6} style={{ textAlign: "center" }}>
                                    <CircularProgress color="secondary" />
                                </Grid>
                            </Grid>
                        </div>
                    ) : (
                            <React.Fragment>
                                {((!this.state.roomEntered || !this.state.started || this.state.finished || this.state.timeExceeded) && !this.state.administration) ? (
                                    <Hidden xsDown>
                                        <div className={styles.bg}></div>
                                    </Hidden>
                                ) : null}
                                {this.state.administration ? (
                                    <Container fixed className={styles.content}>
                                        <Administration onClose={()=>{this.setState({administration:false})}}/>
                                    </Container>
                                ) : (
                                        <Container fixed className={styles.content}>
                                            {this.state.roomEntered ? (
                                                <React.Fragment>
                                                    {this.state.started ? (
                                                        <React.Fragment>
                                                            {!this.state.timeExceeded && !this.state.finished ? (
                                                                <Exam
                                                                    onFinished={this.handleFinished}
                                                                    onTimeExceeded={this.handleTimeExceeded}
                                                                />
                                                            ) : (

                                                                    <FinishExam timeexceeded={this.state.timeExceeded} />
                                                                )}
                                                        </React.Fragment>

                                                    ) : (
                                                            <Login 
                                                                enterRoom={false}
                                                                onStart={this.examStarted}
                                                                openLegalNotice={()=>{this.setState({legalNotice:true})}}
                                                                openPrivacyPolicy={()=>{this.setState({privacyPolicy:true})}}
                                                                openAdministrator={()=>{this.setState({administration:true})}}
                                                                />
                                                        )}
                                                </React.Fragment>

                                            ) : (
                                                    <Login 
                                                    enterRoom={true} 
                                                    onActivate={this.enterRoom} 
                                                    openLegalNotice={()=>{this.setState({legalNotice:true})}}
                                                    openPrivacyPolicy={()=>{this.setState({privacyPolicy:true})}}
                                                    openAdministrator={()=>{this.setState({administration:true})}}
                                                    />
                                                    
                                                )}




                                        </Container>
                                    )}
                            </React.Fragment>
                        )}
                    <PrivacyPolicy open={this.state.privacyPolicy} onClose={()=>{this.setState({privacyPolicy:false})}}/>
                    <LegalNotice open={this.state.legalNotice} onClose={()=>{this.setState({legalNotice:false})}}/>



                    {/* <Hidden xsDown>
                    <div className={styles.bg}></div>
                    </Hidden> */}
                    {/* {this.state.administration ? (
                        <Container fixed className={styles.content}>
                            <Administration />
                        </Container>
                    ) : (
                            <Container fixed className={styles.content}>
                                {this.state.roomEntered ? (
                                    <React.Fragment>
                                        {this.state.started ? (
                                            <React.Fragment>
                                                {!this.state.timeExceeded && !this.state.finished ? (
                                                    <Exam
                                                        onFinished={this.handleFinished}
                                                        onTimeExceeded={this.handleTimeExceeded}
                                                    />
                                                ) : (

                                                        <FinishExam />
                                                    )}
                                            </React.Fragment>

                                        ) : (
                                                <Login />
                                            )}
                                    </React.Fragment>

                                ) : (
                                        <Login />
                                    )}




                            </Container>


                        )}                   */}
                    {/* <Administration/> */}
                    {/* <Login /> */}

                    {/* {!this.state.timeExceeded && !this.state.finished ? (
                            <Exam
                                onFinished={this.handleFinished}
                                onTimeExceeded={this.handleTimeExceeded}
                            />
                        ) : (

                            <FinishExam/>
                        )} */}




                </ThemeProvider>
            </React.Fragment>

        );
    }
}

export default Examinator;
